export default __webpack_public_path__ + "static/media/blue-arrow.9ed2bf65.svg";